import {CreateContractImport} from "components/management-contract/create-contract/create-contract-import/CreateContractImport";
import {useState} from "react";
import {UploadFileContainer} from "./UploadFileContainer";
import {ValidationEmployeeContractContainer} from "./ValidationEmployeeContractContainer";
import {ViewDataContainer} from "./ViewDataContainer";
import {ImportDataContainer} from "./ImportDataContainer";
import {STEPS_IMPORT_EMPLOYEE_CONTRACT} from "../../../../constants/constant";

export const CreateContractImportContainer = () => {
    const [activeStep, setActiveStep] = useState(1)
    const [payload, setPayload] = useState({file: {}})
    const [validatedData, setValidatedData] = useState({})

    const setPayloadData = (payload) => {
        setPayload(payload)
    }

    const setViewData = (data) => {
        setValidatedData(data)
    }

    const onChangeStep = (step) => {
        setActiveStep(step)
    }

    const stepContent = [
        <UploadFileContainer
            payload={payload}
            onChangeStep={onChangeStep}
            setPayloadData={setPayloadData}
        />,
        <ValidationEmployeeContractContainer
            payload={payload}
            onChangeStep={onChangeStep}
            setViewData={setViewData}
        />,
        <ViewDataContainer
            validatedData={validatedData}
            onChangeStep={onChangeStep}
        />,
        <ImportDataContainer
            payload={payload}
            onChangeStep={onChangeStep}
        />
    ]

    return (
        <CreateContractImport steps={STEPS_IMPORT_EMPLOYEE_CONTRACT} activeStep={activeStep} stepContent={stepContent}/>
    )
}
